import React, { useEffect } from "react";
import Heading from "../components/common/Heading";

export default function PrivacyPage() {
  useEffect(() => {
    document.title = "Privacy Policy | HariKunj Resort & Hotel Jodhpur";
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Heading heading="Privacy Policy" title="Privacy Policy" subtitle="Guest Data Protection & Security" />

      <main className="container my-5 py-3" style={{ maxWidth: "960px" }}>
        <div 
          className="p-4 p-md-5 rounded-4 shadow-sm" 
          style={{ 
            background: "#FFFFFF", 
            border: "1px solid rgba(212, 175, 55, 0.3)",
            color: "#0B1D37" 
          }}
        >
          <div className="text-center mb-5">
            <h1 className="h2 fw-bold mb-3" style={{ fontFamily: "'Cinzel Decorative', serif", color: "#0B1D37" }}>
              HariKunj Resort &amp; Hotel Privacy Policy
            </h1>
            <p className="text-muted italic">Last Updated: January 2026 | Dedicated to Guest Data Privacy</p>
            <div style={{ width: "60px", height: "2px", background: "#FEA116", margin: "15px auto" }} />
          </div>

          <section className="mb-4">
            <h2 className="h4 fw-bold text-primary mb-3">1. Information We Collect</h2>
            <p className="lh-lg">
              At <strong>HariKunj Resort &amp; Hotel Jodhpur</strong>, we prioritize the protection of your personal information. We collect data necessary to provide seamless luxury stays, room reservations, and event catering:
            </p>
            <ul className="lh-lg">
              <li>Guest Name, Mobile Number, and Email Address</li>
              <li>Government identification details for statutory guest register compliance</li>
              <li>Reservation preferences, check-in dates, and special dietary/stay requests</li>
            </ul>
          </section>

          <section className="mb-4">
            <h2 className="h4 fw-bold text-primary mb-3">2. How We Use Your Data</h2>
            <p className="lh-lg">
              Your personal information is strictly used for:
            </p>
            <ul className="lh-lg">
              <li>Processing online room bookings, billing, and reservation confirmations</li>
              <li>Fulfilling legal guest register mandates under local Rajasthan hospitality laws</li>
              <li>Sending booking reminders, stay receipts, and exclusive promotional offers</li>
            </ul>
          </section>

          <section className="mb-4">
            <h2 className="h4 fw-bold text-primary mb-3">3. Data Protection &amp; Confidentiality</h2>
            <p className="lh-lg">
              We employ industry-standard encryption and secure server protocols. <strong>HariKunj Resort &amp; Hotel does not sell, rent, or lease guest information to third parties</strong> under any circumstances.
            </p>
          </section>

          <section className="mb-4">
            <h2 className="h4 fw-bold text-primary mb-3">4. Cookie Policy</h2>
            <p className="lh-lg">
              Our website uses minimal operational cookies to optimize page load speeds, retain language preferences, and ensure seamless navigation across our booking engine.
            </p>
          </section>

          <section className="mb-4">
            <h2 className="h4 fw-bold text-primary mb-3">5. Privacy Officer Contact</h2>
            <p className="lh-lg">
              If you have any questions regarding your data or wish to request data removal, please contact our administrative desk:
            </p>
            <p className="fw-bold mb-1">Privacy Officer — HariKunj Resort &amp; Hotel</p>
            <p className="mb-1">Gopal Badi, Chopasni, Jodhpur, Rajasthan 342008</p>
            <p className="mb-1">Phone: +91 9602588882</p>
            <p className="mb-0">Email: reservation@harikunjresort.com</p>
          </section>
        </div>
      </main>
    </>
  );
}
